import { UiComponent } from 'components';
import { Select } from 'components/form';
import { EnrollQuery, EventAdditionalQuery, EventFeedbackQuery } from 'queries';
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  EnrollResponseItemType,
  getApplicationTypeDetailLabel,
  IEnrollResponse,
  IQuestion,
} from 'types';
import { downLoadFile } from 'utils/excel';
import { parseResponse } from 'utils/question';
import { getAttendanceStatus } from './useVolunteerList';
import { formatPhoneNumber } from 'utils/format';
import useDetail from '../useDetail';

function DownloadModal() {
  const { id } = useParams<{ id: string }>();
  const { event } = useDetail();
  const [type, setType] = useState<'additional' | 'feedback'>('additional');

  const { data } = EnrollQuery.useGetAllByEventId(
    Number(id || ''),
    type === 'feedback',
  );
  const { data: feedback } = EventFeedbackQuery.useGet(id || '');
  const { data: additional } = EventAdditionalQuery.useGet(id || '');

  const questions = useMemo(() => {
    return (
      (type === 'additional' ? additional?.questions : feedback?.questions) ||
      []
    );
  }, [type, additional, feedback]);

  const header = useMemo(() => {
    const base = [
      '이름',
      '연락처',
      '생년월일',
      'VMS ID',
      '1365 ID',
      '성별',
      '출결상태',
      '참여유형',
    ];

    return [...base, ...questions.map((question: IQuestion) => question.title)];
  }, [type, questions]);

  const result = useMemo(() => {
    return data?.map((item: IEnrollResponse) => {
      const {
        user: { name, gender, phone, birthDate, vms, id1365 },
        enroll,
      } = item;
      const response =
        (type === 'additional' ? item.additional : item.feedback) || [];

      const result: Record<string, string> = {
        이름: name,
        연락처: formatPhoneNumber(phone),
        생년월일: birthDate,
        'VMS ID': vms,
        '1365 ID': id1365,
        성별: gender === 'MALE' ? '남' : '여',
        출결상태: getAttendanceStatus(
          enroll?.attendanceStatus || 'UNDETERMINED',
        ),
        참여유형: getApplicationTypeDetailLabel(
          enroll?.applicationType,
          event?.applicationTypeQuotaTitle,
        ),
      };

      questions.forEach((question: IQuestion) => {
        const item = response.find(
          (item: EnrollResponseItemType) => Number(item.id) === question.id,
        );
        if (item) {
          result[question.title] = parseResponse(item.response || '');
        }
        return result;
      });

      return result;
    });
  }, [data, questions, type, event]);

  if (!data || !feedback || !additional) return null;

  return (
    <div>
      <Select
        options={[
          { name: '추가정보', value: 'additional' },
          { name: '피드백', value: 'feedback' },
        ]}
        handleChange={(option) => setType(option as 'additional' | 'feedback')}
        value={type}
      />
      <UiComponent.Button
        color="primary"
        variant="border"
        css={{ height: '35px' }}
        onClick={() =>
          downLoadFile(
            result,
            header,
            `${additional?.event.title}_${type === 'additional' ? '추가정보' : '피드백'}`,
          )
        }
      >
        엑셀 다운로드
      </UiComponent.Button>
    </div>
  );
}

export default DownloadModal;
